module.exports = __webpack_public_path__ + "static/media/angular.7d6238e7.png";